import styled from 'styled-components'

import RouterLink from '../RouterLink/RouterLink.styled'

export default styled(RouterLink)`
  text-decoration: none;
`
